"use client"

import { useTranslations } from "next-intl"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface DeleteShippingMethodDialogProps {
  open: boolean
  onOpenChangeAction: (open: boolean) => void
  shippingMethodName: string
  onConfirmAction: () => void
}

export function DeleteShippingMethodDialog({
  open,
  onOpenChangeAction,
  shippingMethodName,
  onConfirmAction,
}: DeleteShippingMethodDialogProps) {
  const t = useTranslations("shippingSettings");
  return (
    <AlertDialog open={open} onOpenChange={onOpenChangeAction}>
      <AlertDialogContent className="w-[calc(100vw-2rem)] sm:w-full">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("deleteTitle")}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogBody>
          <AlertDialogDescription>
            {t("deleteConfirmBody", { name: shippingMethodName || "" })}
          </AlertDialogDescription>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirmAction}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {t("deleteMethod")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
